import sundarban from './../../assets/images/sundorbon.jpg'
import coxbazar from './../../assets/images/coxbazar.png'
import sreemongol from './../../assets/images/sreemongol.jpg'
export const homeData = [
    {
        id: 0,
        title: 'Srimongol',
        info: 'Cox Bazar is a city, fishing port, tourism centre and district headquarters in southeastern Bangladesh. It is famous mostly for its long natural sandy beach, and it ...',
        imgUrl: sreemongol
    },
    {
        id: 1,
        title: 'Cox Bazar',
        info: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus modi sunt exercitationem rerum iste',
        imgUrl: coxbazar
    },
    {
        id: 2,
        title: 'Sundarban',
        info: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Doloribus modi sunt exercitationem rerum iste',
        imgUrl: sundarban
    }
]; 

